import * as React from 'react';
import {
  Popover as MPopover,
  type PopoverProps as MPopoverProps,
} from '@mui/material';
import Typography from '@mui/material/Typography';

export type PopoverProps = {
  content: string;
} & MPopoverProps;

export const Popover: React.FunctionComponent<PopoverProps> = (
  props: PopoverProps,
) => {
  const { content, ...rest } = props;
  return (
    <MPopover
      id="mouse-over-popover"
      sx={{
        pointerEvents: 'none',
      }}
      disableRestoreFocus
      {...rest}
    >
      <Typography sx={{ p: 1, maxWidth: '30rem' }}>{content}</Typography>
    </MPopover>
  );
};
